import { render, staticRenderFns } from "./CancelPurchaseModal.vue?vue&type=template&id=28762819"
import script from "./CancelPurchaseModal.vue?vue&type=script&lang=js"
export * from "./CancelPurchaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports